export const pageSelector = (state) => {
    return state.page;
};